/**
 *
 * common.js
 *
 *
 */
(() => {


	/**
	 *
	 *
	 * Variable
	 *
	 *
	 */
	/**************************************************************
	 * global
	**************************************************************/
	const root     = document.body.dataset.root;
	const mqUpLg   = getComputedStyle(document.documentElement).getPropertyValue('--mqUp-lg');
	const mqDownLg = getComputedStyle(document.documentElement).getPropertyValue('--mqDown-lg');




	/**
	 *
	 * Svg
	 *
	 * imgタグなどからSVGを生成。
	 * common.cssに属するクラスは全てここで一括指定。
	 * ページ固有のものはimgタグやdata属性で直接指定。
	 *
	 */
	window.addEventListener('DOMContentLoaded', () => {
		/**************************************************************
		 * 直接指定
		**************************************************************/
		new changeSvg('img.js-svg',{});
		new changeSvg('[data-class="js-svg"]',{});


		/**************************************************************
		 * 一括指定
		**************************************************************/
		new changeSvg('.c-symbol',{
			svg: root + 'assets/img/common/logo_symbol.svg',
		});
		new changeSvg('.c-arrow2',{
			svg: root + 'assets/img/common/icon/arrow2.svg',
		});
		new changeSvg('.c-arrow3',{
			svg: root + 'assets/img/common/icon/arrow3.svg',
		});
		new changeSvg('.c-down,.c-down2',{
			svg: root + 'assets/img/common/icon/down.svg',
		});
		new changeSvg('.c-blank',{
			svg: root + 'assets/img/common/icon/blank.svg',
		});
		new changeSvg('.c-check',{
			svg: root + 'assets/img/common/icon/check.svg',
		});


	});







	/**
	 *
	 *
	 * Base
	 *
	 *
	 */
	/**************************************************************
	 * cssVariable
	**************************************************************/
	new cssVariable('html',{
		vw: true,
	});


	/**************************************************************
	 * useragent
	**************************************************************/
	new uaLite({
		device    : true,
		deviceType: true,
		browser   : true,
		display   : true,
	});


	/**************************************************************
	 * addClass
	**************************************************************/
	window.addEventListener('load',function(){
		document.body.classList.add('is-load');
	});


	/**************************************************************
	 * smoothScroll
	**************************************************************/
	const easingFuncs = new getEasing({
		easing: 'easeInOutExpo',
	});

	new smoothScroll('a[href^="#"]',{
		documentTop   : true,
		easingFunction: easingFuncs,
		minus         : [0],
		speed         : 600,
	});


	/**************************************************************
	 * isVisible
	**************************************************************/
	const isVisible = () => {
		const targets = document.querySelectorAll('.js-loopslider,.js-loopslider-y,.js-loopslider-y-x-lg');

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				entry.target.classList.toggle('is-visible', entry.isIntersecting);
			});
		}, {
			rootMargin: '100px 0px',
			threshold : 0,
		});

		targets.forEach((target) => {
			observer.observe(target);
		});
	}
	window.addEventListener('load',isVisible);






	/**
	 *
	 *
	 * Layout
	 *
	 *
	 */
	/**************************************************************
	 * popup
	**************************************************************/
	const initPopup = (params) => {
		const comments = document.querySelectorAll('.l-sitemap__random__comment');
		const txt      = document.querySelector('.l-sitemap__random__txt');
		const length   = comments.length;

		let activeComment = null;

		new popup('.l-nav__button',{
			popupSelector      : '.l-sitemap',
			closeButtonSelector: '.l-sitemap__close,.l-sitemap__bg',
			breakPointDown     : null,
			animationTime      : 0,
			smoothScroll       : 'a[href^="#"]',
			popupOpenClass     : 'is-open',
			buttonOpenClass    : 'is-open',
			bodyOpenClass      : 'is-sitemap-open',
			basicId            : 'aria-sitemap',
			basicIdIndex       : false,

			onOpen : ( target , popup ) => {
				if( activeComment ){
					activeComment.classList.remove('is-visible');
				}
				txt.classList.remove('is-bug');

				const randomNum      = Math.floor(Math.random() * length) + 1;
				activeComment = comments[ randomNum - 1 ];

				activeComment.classList.add('is-visible');

				if( randomNum === 6 || randomNum === 7 ){
					txt.classList.add('is-bug');
				}
			},
			onClose: null,
		});
	}
	initPopup();





	/**
	 *
	 *
	 * Project
	 *
	 *
	 */
	/**************************************************************
	 * setTermsLastClass
	**************************************************************/
	const setTermsLastClass = () => {
		const termLists = document.querySelectorAll('.p-card2__meta,.p-tube2__terms');

		for (let i = 0; i < termLists.length; i += 1) {
			const termList = termLists[i];
			const items = termList.querySelectorAll('li');
			const parentRect = termList.getBoundingClientRect();

			let lastVisibleItem = null;
			let lastRight = -Infinity;
			let hasHiddenItem = false;

			for (let j = 0; j < items.length; j += 1) {
				const item = items[j];

				item.classList.remove('is-last');

				const itemRect = item.getBoundingClientRect();
				const itemCenterY = itemRect.top + itemRect.height / 2;

				// 親の高さ内に中心が入っている = 見えている行の要素
				const isVisible =
					itemCenterY >= parentRect.top - 1 &&
					itemCenterY <= parentRect.bottom + 1;

				if (isVisible) {
					// 見えている要素の中で一番右にあるものを最後とする
					if (itemRect.right > lastRight) {
						lastRight = itemRect.right;
						lastVisibleItem = item;
					}
				} else {
					hasHiddenItem = true;
				}
			}

			termList.classList.toggle('is-overflow', hasHiddenItem);

			if (hasHiddenItem && lastVisibleItem !== null) {
				lastVisibleItem.classList.add('is-last');
			}
		}
	};
	window.addEventListener('DOMContentLoaded', setTermsLastClass);
	window.addEventListener('load', setTermsLastClass);
	window.addEventListener('resize', setTermsLastClass);





	/**
	 *
	 *
	 * Component
	 *
	 *
	 */
	/**************************************************************
	 * delayAnimation
	**************************************************************/
	const delayAnimation = () => {
		const target = document.querySelectorAll('.c-anime-twinkle,.c-anime-lightning,.c-anime-rattle');

		target.forEach((item) => {
			const delay = Math.random() * -5;

			item.style.animationDelay = `${delay}s`;
		});
	};
	delayAnimation();






	/**
	 *
	 *
	 * UI
	 *
	 *
	 */
	/**************************************************************
	 * accordion
	 * hoverとclickで親要素のクラスを変えて振り分ける
	 * 小要素のクラスは同じ
	 * スタイルは各々で指定する
	**************************************************************/
	new accordion('.js-accordion-click',{
		addHeight           : true,
		transitionDuration  : 320,
		switchSelector      : '.js-accordion__switch',
		closeSwitchSelector : null,
		panelSelector       : '.js-accordion__panel',
		event               : 'click',
		anotherElementClose : false,
		openClass           : 'is-open',
		firstOpenClass      : 'is-first',
		basicId             : 'aria-accordion-',
		onInit : null,
		onOpen : null,
		onClose: null,
	});


	/**************************************************************
	 * intervalChange
	**************************************************************/
	new intervalChange('.js-slider',{
		sliderSelector : '.js-slider__content',
		autoplay       : true,
		intervalSpeed  : 5000,
		dots           : true,
		dotsInnerHTML  : '<button type="button"></button>',
		dotsActiveClass: 'is-active',
		counter        : false,
		zIndex         : false,
		navigation     : false,

		setClass   : 'is-set',
		startClass : 'is-start',
		changeClass: 'is-change',
		activeClass: 'is-active',
		prevClass  : 'is-prev',
		nextClass  : 'is-next',

		dotsClass: ['c-dots'],
	});


	/**************************************************************
	 * loopSlider
	**************************************************************/
	imagesLoaded( document.querySelectorAll('.js-loopslider img,.js-loopslider-y img,.js-loopslider-y-x-lg img'), function( instance ) {
		new loopSlider( '.js-loopslider:not(.-slow):not(.-fast):not(.-most)', {
			mediaQuery    : null,
			sliderSelector: '.js-loopslider__content',
			resizeDelay   : 0,
			type          : 'horizontal',
			clone         : 10,
			speed         : 0.65,
			addSize       : 10,
		});
		new loopSlider( '.js-loopslider.-slow', {
			mediaQuery    : null,
			sliderSelector: '.js-loopslider__content',
			resizeDelay   : 0,
			type          : 'horizontal',
			clone         : 10,
			speed         : 0.4,
			addSize       : 10,
		});
		new loopSlider( '.js-loopslider.-fast', {
			mediaQuery    : null,
			sliderSelector: '.js-loopslider__content',
			resizeDelay   : 0,
			type          : 'horizontal',
			clone         : 10,
			speed         : 0.8,
			addSize       : 10,
		});
		new loopSlider( '.js-loopslider.-most', {
			mediaQuery    : null,
			sliderSelector: '.js-loopslider__content',
			resizeDelay   : 0,
			type          : 'horizontal',
			clone         : 10,
			speed         : 20,
			addSize       : 10,
		});

		new loopSlider( '.js-loopslider-y', {
			mediaQuery    : null,
			sliderSelector: '.js-loopslider__content',
			resizeDelay   : 0,
			type          : 'vertical',
			clone         : 10,
			speed         : 1.5,
			addSize       : 10,
		});

		new loopSlider( '.js-loopslider-y-x-lg', {
			mediaQuery    : 'screen and ( min-width: '+ mqUpLg +'px )',
			sliderSelector: '.js-loopslider__content',
			resizeDelay   : 0,
			type          : 'vertical',
			clone         : 10,
			speed         : 0.3,
			addSize       : 10,
		});
		new loopSlider( '.js-loopslider-y-x-lg', {
			mediaQuery    : 'screen and ( max-width: '+ mqDownLg +'px )',
			sliderSelector: '.js-loopslider__content',
			resizeDelay   : 0,
			type          : 'horizontal',
			clone         : 10,
			speed         : 0.3,
			addSize       : 10,
		});
	});

	const randomLoopsliderStart = () => {
		const loopSliders = document.querySelectorAll('.js-loopslider');

		loopSliders.forEach((slider) => {
			const content = slider.querySelector('.js-loopslider__content');

			if (!content) {
				return;
			}

			const randomDelay = Math.random() * -20;

			content.style.animationDelay = `${randomDelay}s`;
		});
	}
	randomLoopsliderStart();


	/**************************************************************
	 * currentSection
	**************************************************************/
	new currentSection('.js-currentsection',{
		sectionSelector   : '.js-currentsection__sections > *',
		navigationSelector: '.js-currentsection__nav a',
		centerMode        : true,
	});


	/**************************************************************
	 * typingAnimation
	**************************************************************/
	const typingAnimation = () => {
		const targets = document.querySelectorAll('.js-typing');

		if( targets.length === 0 ){
			return;
		}

		const randomCharacters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!?@#$%&';

		const getRandomNumber = ( min , max ) => {
			return Math.floor( Math.random() * ( max - min + 1 ) ) + min;
		};

		const getRandomCharacter = () => {
			const index = getRandomNumber( 0 , randomCharacters.length - 1 );

			return randomCharacters[ index ];
		};

		const wait = ( time ) => {
			return new Promise(( resolve ) => {
				setTimeout( resolve , time );
			});
		};

		const typeText = async ( target ) => {
			if( target.dataset.typingStarted === 'true' ){
				return;
			}

			const text = target.dataset.typingText;

			if( !text ){
				return;
			}

			target.dataset.typingStarted = 'true';

			let currentText = '';

			target.textContent = '';

			for( let i = 0; i < text.length; i++ ){
				const correctCharacter = text[ i ];
				const eventRandom = Math.random();

				if( eventRandom < 0.1 ){
					target.textContent = currentText + getRandomCharacter();

					await wait( getRandomNumber( 50 , 120 ) );

					target.textContent = currentText;

					await wait( getRandomNumber( 30 , 80 ) );
				}
				else if( eventRandom < 0.2 ){
					target.textContent = currentText + getRandomCharacter();

					await wait( getRandomNumber( 100 , 220 ) );

					target.textContent = currentText;

					await wait( getRandomNumber( 50 , 100 ) );
				}

				currentText += correctCharacter;
				target.textContent = currentText;

				if( ['、', '。', '！', '？', ',', '.', '!', '?'].includes( correctCharacter ) ){
					await wait( getRandomNumber( 250 , 450 ) );
				}
				else{
					await wait( getRandomNumber( 45 , 110 ) );
				}
			}
		};

		const observer = new MutationObserver(() => {
			for( const target of targets ){
				if( target.classList.contains('is-shown') ){
					typeText( target );
				}
			}
		});

		for( const target of targets ){
			observer.observe( target , {
				attributes      : true,
				attributeFilter : ['class'],
			});

			if( target.classList.contains('is-shown') ){
				typeText( target );
			}
		}
	};

	typingAnimation();








	/**
	 *
	 *
	 * Effect
	 *
	 *
	 */
	/**************************************************************
	 * splitText
	**************************************************************/
	new splitText('.js-splittext',{
		mediaQuery  : null,
		type        : 'cssVariable',
		varName     : '--delay',
		delay       : true,
		delayDefault: 0,
		delayChange : 12.5,
		data        : false,
		depth       : false,
		splitClass  : null,
		textClass   : null,
		random      : -1,
	});


	/**************************************************************
	 * runningMouse
	**************************************************************/
	new runningMouse('.js-running',{
		runningTargetSelector: '.js-running__cell',
		reactionRange        : 30,
		moveSize             : 4,
		speed                : .8,
		ease                 : 'power4.out',
		getDefaultEvent      : ['load','resize'],
	});


	/**************************************************************
	 * scrollClass
	**************************************************************/
	window.addEventListener('load', () => {
		const target = document.querySelectorAll('header[class*="p-hero"],.p-hero__illust,.js-load-trigger');

		for (let i = 0; i < target.length; i++) {
			target[i].classList.add('is-shown');
		}
	});


	new scrollClass('.js-trigger',{
		addClass: 'is-shown',
		IntersectionObserverOptions: {
			rootMargin: '-10% 0px -10%',
		},
	});




})();
